import React, {FC, useEffect, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import {
  fetchData,
  getEncryptedRoute,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
} from '../../../reusable'
import {ToastContainer} from 'react-toastify'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faMinus, faPlus} from '@fortawesome/free-solid-svg-icons'
import Swal from 'sweetalert2'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import Select from 'react-select'
import {Tr} from '../../../_metronic/i18n/Tr'

interface TravellerInfoHeaderProps {
  bookingId: string // Assuming bookingId is of type string, adjust as needed
  bookingdetailId: string // Assuming bookingId is of type string, adjust as needed
}

const TravellerInfo: React.FC<TravellerInfoHeaderProps> = ({bookingId, bookingdetailId}) => {
  let t = Tr()
  const {menuId} = useMenuIdPermissions()
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const [idTypeList, setidTypeList] = useState([]) as any
  const [child, setChild] = useState('')
  const [adult, setAdult] = useState('')
  const [infant, setInfant] = useState('')
  const [tourList, setTourList] = useState([])
  const [tourpackageId, settourpackageId] = useState('')
  const [toursId, setToursId] = useState('')
  const [maxPeople, setMaxPeople] = useState('')

  const [selectedStatus, setSelectedStatus] = useState<any>([])
  const [selectedTour, setSelectedTour] = useState<any>([])
  const [quantity, setQuanity] = useState('')
  const [detailBookingId, setDetailBookingId] = useState('')

  const [statusList] = useState([
    {value: '0', label: 'Pending'},
    {value: '1', label: 'Approved'},
    {value: '2', label: 'Rejected'},
    {value: '3', label: 'Cancelled'},
    {value: '4', label: 'Completed'},
  ]) as any

  const [travellerInfo, setTravellerInfo] = useState<any>([
    {firstName: '', lastName: '', id: '', idNumber: '', gender: '', age: ''},
  ])

  const removeTraveller = (id: any, index: number) => {
    if (id == '' || id == undefined || id == null) {
      const updateGuestInfo = [...travellerInfo]

      // Remove the element at the specified index
      updateGuestInfo.splice(index, 1)

      // Update the state with the new array
      setTravellerInfo(updateGuestInfo)
    } else {
      var tmp2 = sessionStorage.getItem('admin')
      // Step 2: Check if the item is not null
      if (tmp2) {
        // Step 3: Parse the JSON string
        var adminData = JSON.parse(tmp2)
        // Step 4: Access the adminId
        var adminId = adminData.adminId
      }
      Swal.fire({
        title: t('Are you sure?'),
        text: t('You Want To Delete this row!'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: t('Ok'),
        cancelButtonText: t('Cancel'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            var param: any = {
              adminId: adminId,
              bookingdetailId: bookingdetailId,
              travellerinfoId: id,
            }
            const response = await fetchData('admin/deletetravellerinfo', param)

            if (response.status == '200') {
              const updatedAccommodation = [...travellerInfo]
              updatedAccommodation.splice(index, 1)
              setTravellerInfo(updatedAccommodation)
              toastsuccessmsg('Deleted Successfully')
            } else {
              toasterrormsg(response.message)
            }
          } catch (error) {
            toasterrormsg('An error occurred while processing your request.')
          }
        }
      })
    }
  }

  const addTraveller = () => {
    const newTraveller = {firstName: '', lastName: '', id: '', idNumber: '', gender: '', age: ''}
    setTravellerInfo([...travellerInfo, newTraveller])
  }

  useEffect(() => {
    tourFilterApiCall()
  }, [])

  useEffect(() => {
    travellerInfoApiCall()
  }, [idTypeList])

  const travellerInfoApiCall = async () => {
    var param: any = {
      bookingId: bookingId,
      categoryId: '5',
    }

    var res = await fetchData('admin/bookingdetail', param)

    if (res.status == '200') {
      var data = res.data[0]

      setDetailBookingId(data.bookingId)

      var bookingDetail = data.bookingDetail.find(
        (item: any) => item.bookingdetailId == bookingdetailId
      )

      setMaxPeople(bookingDetail.actionTypeDetail[0].maxPeople)

      settourpackageId(bookingDetail.actionDetail[0].tourpackageId)
      setToursId(bookingDetail.actionTypeDetail[0].toursId)

      if (bookingDetail.status == '') {
        setSelectedStatus({value: '0', label: 'Pending'})
      } else {
        var selectedStatus = statusList.filter((item: any) => item.value == bookingDetail.status)
        setSelectedStatus(selectedStatus)
      }
      setAdult(bookingDetail.adult)
      setChild(bookingDetail.child)

      setInfant(bookingDetail.infant)
      setQuanity(bookingDetail.quantity)

      let tmpData = bookingDetail.travellerInfo.map((val: any) => {
        return {
          ...val,
          id: idTypeList.find((item: any) => item.value == val.id),
        }
      })
      setTravellerInfo(tmpData || [{firstName: '', lastName: '', id: '', idNumber: '', gender: ''}])
    } else {
    }
  }

  const validate = () => {
    var errotmp: any = {}
    var err = 0
    const validateCharacters = /^[A-Za-z\s]+$/

    travellerInfo.forEach((travellerSlot: any, index: any) => {
      if (
        travellerSlot.firstName.trim() == '' ||
        travellerSlot.firstName.trim() == null ||
        travellerSlot.firstName.trim() == undefined
      ) {
        errotmp[`firstName${index}`] = t('First Name Is Required')
        err = 1
      } else if (!validateCharacters.test(travellerSlot.firstName)) {
        errotmp[`firstName${index}`] = t('First name Is Not Valid')
        err = 1
      } else if (
        travellerSlot.lastName.trim() == '' ||
        travellerSlot.lastName.trim() == null ||
        travellerSlot.lastName.trim() == undefined
      ) {
        errotmp[`lastName${index}`] = t('Last Name Is Required')
        err = 1
      } else if (!validateCharacters.test(travellerSlot.surname)) {
        errotmp[`lastName${index}`] = t('Last Name Is Not valid')
        err = 1
      } else if (
        travellerSlot.id == '' ||
        travellerSlot.id == null ||
        travellerSlot.id == undefined
      ) {
        errotmp[`id${index}`] = t('Traveller Id Type Is Required')
        err = 1
      } else if (
        travellerSlot.idNumber.trim() == '' ||
        travellerSlot.idNumber.trim() == null ||
        travellerSlot.idNumber.trim() == undefined
      ) {
        errotmp[`idNumber${index}`] = t('Id Number Is Required')
        err = 1
      } else if (
        travellerSlot.gender.trim() == '' ||
        travellerSlot.gender.trim() == null ||
        travellerSlot.gender.trim() == undefined
      ) {
        errotmp[`gender${index}`] = t('Gender Is Required')
        err = 1
      } else if (
        travellerSlot.age == '' ||
        travellerSlot.age == null ||
        travellerSlot.age == undefined
      ) {
        errotmp[`age${index}`] = t('Age Is Required')
        err = 1
      }
    })
    setError(errotmp)
    if (err == 0) {
      editBookingDetails()
    }
  }

  const tourFilterApiCall = async () => {
    var response: any = await fetchData('admin/tourPackagesfilter', Object)

    if (response.status == '200') {
      var idtypeData = response.data[4]
      var opt: any = []

      idtypeData['data'].map((val: any) => {
        opt.push({value: val.id, label: val.en_name})
      })
      setidTypeList(opt)
    } else {
      toasterrormsg(response.message)
    }
  }

  const editTravellerList = async () => {
    var childCount: any = child != '' ? parseFloat(child) : 0
    var infantCount: any = infant != '' ? parseFloat(infant) : 0
    var adultCount: any = adult != '' ? parseFloat(adult) : 0

    var total: any = parseFloat(childCount) + parseFloat(infantCount) + parseFloat(adultCount)

    if (total > travellerInfo.length) {
      toasterrormsg('Please Add Details of Total ' + total + ' People')
    } else if (total < travellerInfo.length) {
      toasterrormsg('Please Set People Count to ' + travellerInfo.length + ' People')
    } else if (total == '0' && travellerInfo.length == '0') {
      toasterrormsg('Please Add People Count And Details Before Updating')
    } else if (Number.isNaN(total)) {
      toasterrormsg('Please Add People Count')
    } else {
      setDisable(true)
      setLoading(true)

      var tmp2 = sessionStorage.getItem('admin')
      // Step 2: Check if the item is not null
      if (tmp2) {
        // Step 3: Parse the JSON string
        var adminData = JSON.parse(tmp2)
        // Step 4: Access the adminId
        var adminId = adminData.adminId
      }

      for (const item of travellerInfo) {
        const param = {
          travellerinfoId: item.travellerinfoId,
          firstName: item.firstName.trim(),
          lastName: item.lastName.trim(),
          id: item.id.value,
          idNumber: item.idNumber,
          age: item.age,
          adminId: adminId,
          gender: item.gender,
          bookingdetailId: item.bookingdetailId,
        }

        // if (item.travellerinfoId != '' || item.travellerinfoId != undefined) {
        //   delete param.bookingdetailId
        // } else {
        // }
        // Conditionally delete the key
        if (item.travellerinfoId !== '' && item.travellerinfoId !== undefined) {
          delete param.bookingdetailId
        } else {
          // Add the key back if needed based on different conditions
          param.bookingdetailId =
            item.bookingdetailId == '' || item.bookingdetailId == undefined ? bookingdetailId : ''
        }

        var res: any = ''
        res = await fetchData('admin/addedittravellerinfo', param)
      }
      if (res.status == '200') {
        travellerInfoApiCall()
        toastsuccessmsg('Updated Successfully')
        setLoading(false)
        setDisable(false)
      } else {
        setLoading(false)
        setDisable(false)
        toasterrormsg(res.message)
      }
    }
  }

  const handleIdChange = (index: any, field: string, selectedOption: any) => {
    var selectedIdSlot: any = [...travellerInfo]
    selectedIdSlot[index][field] = selectedOption
    setTravellerInfo(selectedIdSlot)
  }
  const [error, setError] = useState([
    {
      firstName: '',
      surName: '',
      email: '',
      contactNumber: '',
    },
  ]) as any

  const editBookingDetails = async () => {
    var childCount: any = child != '' ? parseFloat(child) : 0
    var infantCount: any = infant != '' ? parseFloat(infant) : 0
    var adultCount: any = adult != '' ? parseFloat(adult) : 0

    var guestListChildCount = 0
    var guestListAdultCount = 0
    var guestListInfantCount = 0

    travellerInfo.forEach((item: any) => {
      if (item.age >= 17) {
        guestListAdultCount++
      } else if (item.age >= 4 && item.age <= 16) {
        guestListChildCount++
      } else if (item.age <= 3) {
        guestListInfantCount++
      }
    })
    var total: any = parseFloat(childCount) + parseFloat(infantCount) + parseFloat(adultCount)

    if (total > maxPeople || travellerInfo.length > maxPeople) {
      toasterrormsg(`Maximum Traveller Limit Is  ${maxPeople}.`)
      return false
    } else if (adultCount < 1) {
      toasterrormsg('At Least 1 Adult Traveller Is Required')
      return false
    } else if (adultCount !== guestListAdultCount) {
      toasterrormsg(
        `Mismatch in adult details. You have entered Total ${adultCount} Adults (17+ years), but only ${guestListAdultCount} are listed.`
      )
      return false
    } else if (childCount !== guestListChildCount) {
      toasterrormsg(
        `Mismatch in Children details. You have entered Total  ${childCount} Children (ages 4-16), but only ${guestListChildCount}are listed.`
      )
      return false
    } else if (infantCount !== guestListInfantCount) {
      toasterrormsg(
        `Mismatch in Infants details. You have entered Total ${infantCount} Infants (3 years or younger), but only ${guestListInfantCount} are listed.`
      )
      return false
    } else if (total > travellerInfo.length) {
      toasterrormsg('Please Add Details of Total ' + total + ' People')
    } else if (total < travellerInfo.length) {
      toasterrormsg('Please Set People Count to ' + travellerInfo.length + ' People')
    } else if (total == '0' && travellerInfo.length == '0') {
      toasterrormsg('Please Add People Count And Details Before Updating')
    } else if (Number.isNaN(total)) {
      toasterrormsg('Please Add People Count')
    } else {
      setDisable(true)
      setLoading(true)
      var tmp2 = sessionStorage.getItem('admin')
      // Step 2: Check if the item is not null
      if (tmp2) {
        // Step 3: Parse the JSON string
        var adminData = JSON.parse(tmp2)
        // Step 4: Access the adminId
        var adminId = adminData.adminId
      }
      var param: any = {
        updateStatus: '1',
        bookingId: String(bookingId),
        bookingdetailId: bookingdetailId,
        bookingDetailStatus: selectedStatus ? selectedStatus.value : '',
        adminId: adminId,
        quantity: String(quantity),
        adult: adult == '' ? '0' : String(adult),
        child: child == '' ? '0' : String(child),
        infant: infant == '' ? '0' : String(infant),
      }
      var res = await fetchData('admin/edittourpackagebooking', param)
      if (res.status == '200') {
        setDisable(false)
        editTravellerList()
        setLoading(false)
      } else {
        toasterrormsg(res.message)
        setDisable(false)
        setLoading(false)
      }
    }
  }

  const handleTravellerChange = (index: number, field: string, value: string) => {
    var newTravellers: any = [...travellerInfo]
    newTravellers[index][field] = value
    setTravellerInfo(newTravellers)
  }

  const tourDetailListApiCall = async () => {
    var param: any = {
      tourpackageId: String(tourpackageId),
    }
    var response: any = await fetchData('vendor/public/tourpackageDetails', param)
    if (response.status == '200') {
      var tourList = response.data[0]['toursDetail']
      var opt: any = []
      tourList.map((val: any) => {
        opt.push({value: val.toursId, label: val.en_name})
      })

      setTourList(opt)
      var selectedTour = opt.filter((item: any) => item.value == toursId)
      setSelectedTour(selectedTour[0])
    } else {
    }
  }

  useEffect(() => {
    tourDetailListApiCall()
  }, [tourpackageId])

  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t('Edit Traveller List')}</PageTitle>
      <div className='d-flex flex-column flex-column-fluid'>
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          <div className='form d-flex flex-column flex-lg-row'>
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              <div className='tab-content'>
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    <div className='card card-flush py-4'>
                      <div className='card-header d-flex'>
                        {/* <!--begin::Card title--> */}
                        <div className='card-title'>
                          <h2>{t('Traveller List')}</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                      </div>
                      <div className='card-body pt-0'>
                        <div className='row'>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'> {t('Total Child')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='child'
                              className='form-control mb-2'
                              placeholder={t('Child')}
                              value={child}
                              onChange={(e) => {
                                setChild(e.target.value)
                              }}
                            />
                            {/* <!--end::Input--> */}
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'> {t('Total Adult')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='adult'
                              className='form-control mb-2'
                              placeholder={t('Adult')}
                              value={adult}
                              onChange={(e) => {
                                setAdult(e.target.value)
                              }}
                            />
                            {/* <!--end::Input--> */}
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'> {t('Total Infant')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='infant'
                              className='form-control mb-2'
                              placeholder={t('Infant')}
                              value={infant}
                              onChange={(e) => {
                                setInfant(e.target.value)
                              }}
                            />
                            {/* <!--end::Input--> */}
                          </div>
                        </div>
                      </div>
                      {travellerInfo.length > 0 ? (
                        travellerInfo.map((item: any, index: any) => {
                          return (
                            <div key={index}>
                              <div className='card-body pt-0'>
                                {/* <!--begin::Input group--> */}
                                <div className='row mb-0'>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-4 form-label'>
                                      {t('First Name')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='name'
                                      className='form-control mb-2'
                                      placeholder={t('First Name')}
                                      value={item.firstName}
                                      onChange={(event: any) =>
                                        handleTravellerChange(
                                          index,
                                          'firstName',
                                          event.target.value
                                        )
                                      }
                                    />
                                    {/* <!--end::Input--> */}
                                    <label className='text-danger fw-bold'>
                                      {error[`firstName${index}`] || ''}
                                    </label>
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-4 form-label'>
                                      {t('Last Name')}
                                    </label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input
                                      type='text'
                                      name='lastName'
                                      className='form-control mb-2'
                                      placeholder={t('Last Name')}
                                      value={item.lastName}
                                      onChange={(event: any) =>
                                        handleTravellerChange(index, 'lastName', event.target.value)
                                      }
                                    />
                                    {/* <!--end::Input--> */}
                                    <label className='text-danger fw-bold'>
                                      {error[`lastName${index}`] || ''}
                                    </label>
                                  </div>

                                  <div className='col-lg-4 my-3'>
                                    {/* <!--begin::Label--> */}
                                    <label className='required fs-4 form-label'>
                                      {t('Select Id Type')}
                                    </label>

                                    <Select
                                      name='selectIdType'
                                      id='selectIdType'
                                      placeholder={t('Select Id Type')}
                                      isSearchable={true}
                                      options={idTypeList}
                                      value={item.id}
                                      onChange={(selectedOption) => {
                                        handleIdChange(index, 'id', selectedOption)
                                      }}
                                      styles={{
                                        container: (provided) => ({...provided, width: '100%'}),
                                        control: (provided) => ({...provided, minHeight: 43}),
                                      }}
                                    />
                                    <label className='text-danger fw-bold'>
                                      {error[`id${index}`] || ''}
                                    </label>
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    <label className='required fs-4 form-label'>
                                      {t('Id Number')}
                                    </label>
                                    <input
                                      type='text'
                                      name='idNumber'
                                      className='form-control '
                                      placeholder={t('Id Number')}
                                      value={item.idNumber}
                                      onChange={(event: any) =>
                                        handleTravellerChange(index, 'idNumber', event.target.value)
                                      }
                                    />
                                    {/* <!--end::Input--> */}
                                    <label className='text-danger fw-bold'>
                                      {error[`idNumber${index}`] || ''}
                                    </label>
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    <div className='row'>
                                      <label className='fs-4 form-label'>{t('Gender')}</label>
                                      {/* <!--end::Label--> */}
                                      <div className='col-4 my-2'>
                                        <label className='d-flex text-start' data-kt-button='true'>
                                          <span className='form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1'>
                                            <input
                                              className='form-check-input'
                                              type='radio'
                                              name={`gender${index}`}
                                              value='male'
                                              checked={item.gender == 'male'}
                                              onChange={(event: any) => {
                                                handleTravellerChange(
                                                  index,
                                                  'gender',
                                                  event.target.value
                                                )
                                              }}
                                            />
                                          </span>
                                          {/* <!--end::Radio--> */}
                                          {/* <!--begin::Info--> */}
                                          <span className='ms-5'>
                                            <span className='fs-4 fw-bold text-gray-800 d-block'>
                                              {t('Male')}
                                            </span>
                                          </span>
                                          {/* <!--end::Info--> */}
                                        </label>
                                      </div>
                                      <div className='col-4 my-2'>
                                        <label className='d-flex text-start' data-kt-button='true'>
                                          {/* <!--begin::Radio--> */}
                                          <span className='form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1'>
                                            <input
                                              className='form-check-input'
                                              type='radio'
                                              name={`gender${index}`}
                                              value='female'
                                              checked={item.gender == 'female'}
                                              onChange={(event: any) => {
                                                handleTravellerChange(
                                                  index,
                                                  'gender',
                                                  event.target.value
                                                )
                                              }}
                                            />
                                          </span>
                                          {/* <!--end::Radio--> */}
                                          {/* <!--begin::Info--> */}
                                          <span className='ms-5'>
                                            <span className='fs-4 fw-bold text-gray-800 d-block'>
                                              {t('Female')}
                                            </span>
                                          </span>
                                          {/* <!--end::Info--> */}
                                        </label>
                                      </div>
                                      <label className='text-danger fw-bold'>
                                        {error[`gender${index}`] || ''}
                                      </label>
                                    </div>
                                  </div>
                                  <div className='col-lg-4 my-3'>
                                    <label className='required fs-4 form-label'>{t('Age')}</label>
                                    <input
                                      type='text'
                                      name='age'
                                      className='form-control '
                                      placeholder={t('Age')}
                                      value={item.age}
                                      onChange={(event: any) =>
                                        handleTravellerChange(index, 'age', event.target.value)
                                      }
                                    />
                                    {/* <!--end::Input--> */}
                                    <label className='text-danger fw-bold'>
                                      {error[`age${index}`] || ''}
                                    </label>
                                  </div>
                                </div>
                              </div>

                              <div className='card-body pt-0'>
                                {/* <!--begin::Input group--> */}
                                <div className='row mb-0'>{/* <!--end::Input--> */}</div>
                                {/* <!--end::Input group--> */}
                                <div className='d-flex justify-content-end gap-3'>
                                  <div>
                                    <button
                                      className='btn btn-danger'
                                      onClick={() => removeTraveller(item.travellerinfoId, index)}
                                    >
                                      <FontAwesomeIcon icon={faMinus} />
                                    </button>
                                  </div>
                                  <div>
                                    <button className='btn btn-success' onClick={addTraveller}>
                                      <FontAwesomeIcon icon={faPlus} />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        })
                      ) : (
                        <>
                          <div className='text-center '>
                            <div className='d-flex justify-content-center align-items-center flex-column '>
                              <h2 className='fs-2x fw-bold '>
                                {t('Sorry Currently There are no Travellers')}
                              </h2>
                            </div>
                          </div>
                          <div className='d-flex justify-content-center p-5'>
                            <img
                              className='mw-100 mh-300px'
                              alt=''
                              src={toAbsoluteUrl('/media/illustrations/sketchy-1/2.png')}
                            />
                          </div>
                        </>
                      )}
                      <div className='d-flex justify-content-center'>
                        {travellerInfo.length == 0 ? (
                          <>
                            <button className='btn btn-success' onClick={addTraveller}>
                              {t('Add Traveller')}
                            </button>
                          </>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='d-flex justify-content-end'>
                {/* <!--begin::Button--> */}
                <Link
                  to={getEncryptedRoute('../viewtourbookingdetails/', {menuId:menuId})}
                  id='kt_ecommerce_add_product_cancel'
                  className='btn btn-light me-5'
                  state={{bookingId: detailBookingId}}
                >
                  {t('Cancel')}
                </Link>

                <button
                  onClick={() => {
                    validate()
                  }}
                  type='button'
                  disabled={disable}
                  className='btn btn-primary'
                >
                  <span className='indicator-label'>{t('Save')}</span>
                  {loading && (
                    <span
                      className='spinner-border spinner-border-sm mx-2'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  )}
                </button>

                {/* <!--end::Button--> */}
              </div>
            </div>
            {/* <!--end::Main column--> */}
          </div>
          {/* <!--end::Form--> */}
        </div>
        {/* <!--end::Content--> */}
      </div>
    </>
  )
}

export {TravellerInfo}
